import { Component, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/service/http.service';
import { ChartjsData } from 'src/app/chartjs-data';
import { ChartjsDataElement } from 'src/app/chartjs-data-element';
import * as moment from 'moment';

@Component({
  selector: 'app-sales-report-all-agents',
  templateUrl: './sales-report-all-agents.component.html',
  styleUrls: ['./sales-report-all-agents.component.css']
})
export class SalesReportAllAgentsComponent {
  borderColors: string[] = ["rgb(0, 0, 255)", "rgb(50, 205, 50)"];
  backgroundColors: string[] = [
    "rgba(255, 165, 0, 1.0)",
    "rgba(54, 162, 235, 0.2)",
    "rgba(0, 0, 255, 1.0)",
    "rgba(0, 192, 255, 1.0)",
    "rgba(153, 102, 255, 0.2)",
    "rgba(255, 159, 64, 0.2)",
    "rgba(255, 206, 86, 0.2)",
    "rgba(75, 192, 192, 0.2)",
    "rgba(153, 102, 255, 0.2)",
    "rgba(255, 159, 64, 0.2)",
    "rgba(255, 99, 132, 0.2)",
    "rgba(54, 162, 235, 0.2)",
    "rgba(255, 206, 86, 0.2)",
    "rgba(75, 192, 192, 0.2)",
    "rgba(153, 102, 255, 0.2)",
    "rgba(255, 159, 64, 0.2)",
    "rgba(255, 206, 86, 0.2)",
    "rgba(75, 192, 192, 0.2)",
    "rgba(153, 102, 255, 0.2)",
    "rgba(255, 159, 64, 0.2)"
  ];
  bookingsChartData: ChartjsData | null = null;
  years: number[] = [];
  selectedYear: number = moment().year();
  @ViewChild("chart") pieChart: any;

  initYears() {
    const thisYear = moment().year();
    for (let i = 0; i < 4; i++) {
      this.years.push(thisYear - i);
    }
    this.selectedYear = thisYear;
  }

  constructor(
    private httpService: HttpService
  ) {
    this.initYears();
    this.updateData(this.selectedYear);
  }

  updateChart() {
    this.updateData(this.selectedYear);
    this.pieChart.refresh();
  }

  updateData(year: number) {
    this.httpService.getYearlyBookingsForAllAgents(year).subscribe(res => {
      let datasets: ChartjsDataElement[] = [];
      console.log(res);
      let count = 1;
      let labels: string[] = [];
      let isFirst = true;
      res.sort((a,b) => {
        if(a.bookingNumber < b.bookingNumber){
          return -1;
        }
        if(a.bookingNumber > b.bookingNumber){
          return 1;
        }
        return 0;
      });
      for (let bookingData of res) {
        labels.push(bookingData.agent.name);
        if (isFirst) {
          const dataElement: ChartjsDataElement = {
            label: "",
            data: [],
            fill: true,
            borderColor: this.borderColors[count - 1],
            tension: 0.1,
            backgroundColor: []
          };
          datasets.push(dataElement);
          isFirst = false;
        }
        const backGroundColorIndex = bookingData.agent.id - 1;
        datasets[0].data.push(bookingData.bookingNumber);
        datasets[0].backgroundColor.push(this.backgroundColors[backGroundColorIndex]);
        count++;
      }
      this.bookingsChartData = {
        labels: labels,
        datasets: datasets
      };
    });
  }
}